"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var BB8AuthPanel_1 = __importDefault(require("./BB8AuthPanel"));

require("./BB8TopNav.scss"); // TODO: dynamic class name for active link


var BB8TopNav = function BB8TopNav(_a) {
  var user = _a.user,
      logout = _a.logout,
      children = _a.children,
      _b = _a.showAuth,
      showAuth = _b === void 0 ? true : _b,
      subHeader = _a.subHeader;
  return react_1.default.createElement("header", {
    className: "navbar-links-wrapper " + (subHeader && 'sub-header')
  }, react_1.default.createElement("div", {
    className: !subHeader ? 'navbar-links' : 'navbar-sub-links'
  }, react_1.default.createElement("nav", null, children), showAuth && react_1.default.createElement(BB8AuthPanel_1.default, {
    user: user,
    logout: logout
  })));
};

BB8TopNav.defaultProps = {
  subHeader: false
};
exports.default = BB8TopNav;